'use client';

import { Tabs } from '@petsmart-ui/sparky';

import { dataLayerPush, getBaseUrlJoined } from '@libs/analytics';

import { MarketingSection } from './MarketingSection';
import { RecursiveMenu } from './RecursiveMenu';
import type { CategoryTypes, TabbedMenuProps } from './types';
import { getCategoryPath, trackingData } from './utils';

export function TabbedMenu({ parentCategories, path, parentCategory }: TabbedMenuProps) {
    return (
        <div>
            <Tabs
                className="submenu-container__list"
                changeTabOnHoverAndFocus
                onTabClick={(_e, i) => {
                    dataLayerPush(
                        trackingData({
                            selection: `${parentCategory} | ${parentCategories[i].displayText}`,
                            link_url: getBaseUrlJoined(parentCategories[i].link),
                        })
                    );
                }}
            >
                {
                    // NOTE: Remove duplicate categories to avoid phantom menu items on back button click
                    // TODO: should be remove if we can get the category stack to work properly with unique IDs
                    parentCategories
                        ?.filter((category, index, self) => index === self.findIndex(c => c.sysId === category.sysId))
                        .map(({ sysId, displayText, categories, specialType, rightMenuCard, wrapListItems, link }) => {
                            const newPath = getCategoryPath(path, displayText);

                            return (
                                <Tabs.Panel key={sysId} title={displayText} href={link}>
                                    {/* id is necessary to style legacy header tab submenus */}
                                    <ul
                                        className="submenu-container__list"
                                        id={displayText?.toLowerCase().trim().split(' ').join('-')}
                                    >
                                        <RecursiveMenu
                                            path={newPath}
                                            parentCategory={`${parentCategory} | ${displayText}`}
                                            parentCategories={categories as CategoryTypes[]}
                                            wrapListItems={Boolean(wrapListItems)}
                                        />
                                    </ul>
                                    <MarketingSection
                                        rightMenuCard={rightMenuCard}
                                        childCategories={categories as CategoryTypes[]}
                                        specialType={specialType}
                                        path={newPath}
                                    />
                                </Tabs.Panel>
                            );
                        })
                }
            </Tabs>
        </div>
    );
}
